import React from 'react';
import styles from './filterMatchEyecatcher.scss';
import IFilterMatchEyecatcher from './filterMatchEyecatcher.d';
import FilterMatchPanel from '../filterMatchPanel/filterMatchPanel';

function FilterMatchEyecatcher(props: IFilterMatchEyecatcher) {
    const { matchingFilters, nonMatchingFilters, onPanelClick, isMobile } = props;
    return (
        <div className={styles.filter_match_eyecatcher}>
            <FilterMatchPanel
                matchingFilters={matchingFilters}
                nonMatchingFilters={nonMatchingFilters}
                onPanelClick={onPanelClick}
                isMobile={isMobile}
            />
        </div>
    );
}

export default FilterMatchEyecatcher;
